import { render, staticRenderFns } from "./ContractorTransactions.vue?vue&type=template&id=4bf05050&"
import script from "./ContractorTransactions.vue?vue&type=script&lang=js&"
export * from "./ContractorTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports